import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CocheraNivel, CocheraSinNivel } from '@pages/consorcios/consorcios.config';

@Component({
  selector: 'app-cocheras-view',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './cocheras-view.component.html',
  styleUrl: './cocheras-view.component.scss'
})
export class CocherasViewComponent {
  @Input() cocheras:CocheraNivel[] | CocheraSinNivel=[];
  @Input() tieneNiveles:boolean=true;
  @Input() selectedNivel:number=1;
  @Input() selectedNumero?:number;
  @Output() selectedNivelChange = new EventEmitter<number>();
  @Output() selectedNumeroChange = new EventEmitter<number>();
  @Output() onSelect = new EventEmitter<{nivel:number, numero:number}>()

   viewNivel:number=1;

  select(nivel:number, numero:number){
    this.selectedNivel = nivel;
    this.selectedNumero = numero;
    this.selectedNivelChange.emit(nivel);
    this.selectedNumeroChange.emit(numero);
    this.onSelect.emit({nivel, numero});
  }
}
